export const filterUniqueKeys = (
  data: any,
  filters: any,
  keys: Array<string>
) => {
  const newState = filters;
  for (const key of keys) {
    newState[key].options = [...new Set(data.map((item: any) => item[key]))];
  }
  return Object.values(newState).sort((a: any, b: any) => a.id - b.id);
};
